// import { Navigate } from "react-router-dom";
// import { useAdmin } from "../context/AdminContext";

// const AdminProtectedRoute = ({ children }) => {
//   const { isLoggedIn, loading } = useAdmin();


//   console.log("🛡 ProtectedRoute", { isLoggedIn, loading });

//   if (loading) return <p>Loading...</p>;

//   return isLoggedIn ? children : <Navigate to="/admin/login" />;
// };

// export default AdminProtectedRoute;
import { Navigate, Outlet } from "react-router-dom";
import { useAdmin } from "../context/AdminContext";

const AdminProtectedRoute = () => {
  const { isLoggedIn, loading } = useAdmin();

  console.log("🛡 ProtectedRoute", { isLoggedIn, loading });

  if (loading) return <p>Loading...</p>;

  return isLoggedIn ? <Outlet /> : <Navigate to="/admin/login" replace />;
};

export default AdminProtectedRoute;
